module.exports = __webpack_public_path__ + "img/ntu-icon.261d4def.jpg";